import { Action, createReducer, on } from '@ngrx/store';
import { digitalCourseAdapter } from './digital-course.entity';
import { DigitalCourseState } from './digital-course.state';

import * as fromAction from './digital-course.action';
import { DigitalCourseFilter } from '@modules/course/digitalcourse/models';

const initialState: DigitalCourseState = digitalCourseAdapter.getInitialState({
  selectedDigitalCourseId: null,
  error: null,
  totalCount: 0,
  filter: new DigitalCourseFilter(),
  advantages: [],
  questions: [],
});

const _digitalCourseReducer = createReducer(
  initialState,
  on(fromAction.AddDigitalCourses, (state, { courses }) => {
    return digitalCourseAdapter.setAll(courses, state);
  }),
  on(fromAction.AddDigitalCourse, (state, { course }) => {
    return digitalCourseAdapter.upsertOne(course, state);
  }),
  on(fromAction.AddSelectedDigitalCourse, (state, { digitalCourseId }) => {
    return digitalCourseAdapter.addMany([], { ...state, selectedDigitalCourseId: digitalCourseId });
  }),
  on(fromAction.RemoveSelectedDigitalCourse, (state) => {
    return digitalCourseAdapter.addMany([], { ...state, selectedDigitalCourseId: null });
  }),
  on(fromAction.AddCourseAdvantage, (state, { advantages }) => {
    return digitalCourseAdapter.addMany([], { ...state, advantages: advantages });
  }),
  on(fromAction.AddCourseQuestion, (state, { questions }) => {
    return digitalCourseAdapter.addMany([], { ...state, questions });
  }),
  on(fromAction.AddTotalCount, (state, { totalCount }) => {
    return digitalCourseAdapter.addMany([], { ...state, totalCount: totalCount });
  }),
  on(fromAction.AddError, (state, { error }) => {
    return digitalCourseAdapter.addMany([], { ...state, error: error });
  })
);

export function digitalCourseReducer(state: DigitalCourseState = initialState, action: Action): DigitalCourseState {
  return _digitalCourseReducer(state, action);
}
